import { render } from "./PersonalProfile.vue?vue&type=template&id=3a25b3eb&scoped=true"
import script from "./PersonalProfile.vue?vue&type=script&lang=js"
export * from "./PersonalProfile.vue?vue&type=script&lang=js"

import "./PersonalProfile.vue?vue&type=style&index=0&id=3a25b3eb&scoped=true&lang=css"

import exportComponent from "/var/www/gl_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a25b3eb"]])

export default __exports__